module.exports = __webpack_public_path__ + "img/closemobie.bae5cfe0.png";